import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Invoice from 'src/components/project-billing/models/InvoiceMaster';

interface IInvoiceDescriptionDialogProps {
    dialogName: string;
    handleConfirm?: (editedText: string) => void;
    hideDialog: () => void;
    invoice?: Invoice;
}

const InvoiceDescriptionDialog = (props: IInvoiceDescriptionDialogProps) => {
    const [initialText, setInitialText] = useState(undefined);
    const [text, setText] = useState(undefined);

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (props.invoice) {
            if (!!props?.invoice?.details && props?.invoice?.header) {
                if (initialText === undefined) {
                    setInitialText(
                        props?.invoice.header
                    );
                }
                setText(
                    props?.invoice?.header
                );
            } else {
                if (initialText === undefined) {
                    setInitialText(
                        `Land Brokerage Services, time, facility, office back-up personnel and expense from ${formatDateString(true)} through ${formatDateString(false)} regarding:`
                    );
                }
                setText(
                    `Land Brokerage Services, time, facility, office back-up personnel and expense from ${formatDateString(true)} through ${formatDateString(false)} regarding:`
                );
            }
        }
    }, [props.invoice]);

    const onCreate = () => {
        console.log('DefineBudgetCategoryDialog onCreate()');
    };

    const OKClicked = () => {
        props.handleConfirm(text !== initialText ? text : '');
        props.hideDialog();
    };

    const formatDateString = (beginning: boolean): string => {
        const options: Intl.DateTimeFormatOptions = { month: 'long' };
        const date = beginning ? (!!props?.invoice?.beginDate ? new Date(props.invoice.beginDate) : new Date()) : (!!props?.invoice?.endDate ? new Date(props.invoice.endDate) : new Date());
        const month = date.toLocaleString('en-US', options);
        const day = date.getDate();
        const year = date.getFullYear();

        const suffix =
          day % 10 === 1 && day !== 11
            ? 'st'
            : day % 10 === 2 && day !== 12
            ? 'nd'
            : day % 10 === 3 && day !== 13
            ? 'rd'
            : 'th';

        return `${month} ${day}${suffix}, ${year}`;
    };

    return (
        <Dialog title="Invoice Description" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '15%' }}>
            <div style={{ display: 'flex', justifyContent: 'left', width: '100%'}}>
                <form style={{width: '100%'}}>
                    <label>Invoice #:<span style={{fontWeight: 'bold', fontSize: '15px'}}>{` ` + (props?.invoice?.number ? props.invoice.number : '')}</span></label>
                    <textarea
                        style={{ width: '100%', height: '15rem', resize: 'none' }}
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                    />
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={text !== initialText ? 'Save' : 'Close'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default InvoiceDescriptionDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/InvoiceDescriptionDialog.tsx